// extracted by mini-css-extract-plugin
module.exports = {"cardWidth":"ConfigSection_cardWidth__2aZ6O"};